// deploy-pipelines-run-overrides (Wave 4, AC-9) — labels the config panel's effective-branch
// row so a reader can tell a pipeline-OWNED default from the legacy image-group value, per
// `PipelineBuildSourceDto.IsPipelineOwnedDefault`. Extracted as a pure helper so the label text
// is asserted directly by a pure-logic jest suite rather than only through the component
// (test-plan.md: "AC-9 | x (helper)").
export const EffectiveBranchSource = {
	PipelineOwned: 'pipelineOwned',
	Legacy: 'legacy'
};

export const EFFECTIVE_BRANCH_SOURCE_LABEL = {
	[EffectiveBranchSource.PipelineOwned]: 'Pipeline default',
	[EffectiveBranchSource.Legacy]: 'Legacy image-group value'
};

/**
 * @param {boolean|undefined} isPipelineOwnedDefault  `PipelineBuildSourceDto.IsPipelineOwnedDefault`.
 * @returns {string}  One of `EffectiveBranchSource`'s two states. Anything other than a strict
 *                     `true` (including `undefined`, from a not-yet-resolved `buildSource`, or a
 *                     never-run pre-slice pipeline) resolves to `Legacy` — the honest state
 *                     before this pipeline has ever pinned or explicitly saved its own branch.
 */
export const resolveEffectiveBranchSource = (isPipelineOwnedDefault) =>
	isPipelineOwnedDefault === true ? EffectiveBranchSource.PipelineOwned : EffectiveBranchSource.Legacy;

/**
 * @param {boolean|undefined} isPipelineOwnedDefault
 * @returns {string}  The display label for the resolved source — never undefined.
 */
export const resolveEffectiveBranchLabel = (isPipelineOwnedDefault) =>
	EFFECTIVE_BRANCH_SOURCE_LABEL[resolveEffectiveBranchSource(isPipelineOwnedDefault)];

export default resolveEffectiveBranchLabel;
